import { useEffect, useRef } from "react";
import type { ProcedureType, SourcingEventPatchDto } from "../../../../../autogen/bff-api";
import { earliestDeadlineAfterNotice } from "../../../../../common/procurement/earliestTenderDeadline";
import { hasRequestStage, isQualificationScheme, isTwoStageProcedure } from "../utils/procedure";

const SUGGESTED_REQUEST_DEADLINE_DAYS = 35;

const suggestedRequestDeadlineIso = (announcementDate: string | null): string =>
  earliestDeadlineAfterNotice({
    minimumDays: SUGGESTED_REQUEST_DEADLINE_DAYS,
    publishedAt: null,
    plannedAnnouncement: announcementDate,
    now: new Date(),
  });

interface SuggestedRequestDeadline {
  publicContext: { procedureType?: ProcedureType | null; governingSchemeId?: string | null } | null;
  announcementDate: string | null;
  requestDeadline: string | null;
  isSaving: boolean;
  updateField: (fields: Partial<SourcingEventPatchDto>) => void;
}

export const useSuggestedRequestDeadline = ({
  publicContext,
  announcementDate,
  requestDeadline,
  isSaving,
  updateField,
}: SuggestedRequestDeadline): void => {
  const seededRef = useRef(false);

  useEffect(() => {
    if (seededRef.current) return;
    if (!hasRequestStage(publicContext)) return;
    if (requestDeadline !== null) return;
    if (isSaving) return;
    seededRef.current = true;
    updateField({
      eventData: {
        requestDeadline: suggestedRequestDeadlineIso(announcementDate),
        requestDeadlineConfirmed: false,
      },
    });
  }, [publicContext, announcementDate, requestDeadline, isSaving, updateField]);
};
